import {defineRouting} from "next-intl/routing";

export const routing = defineRouting({
  locales: ["en", "hi"],
  defaultLocale: "en",
  localePrefix: "always",
  localeCookie: {
    maxAge: 60 * 60 * 24 * 365, // 1 year
    sameSite: "lax" as const,
    secure: process.env.NODE_ENV === "production", // HTTPS only in production
    path: "/",
  },
});

export type AppLocale = (typeof routing.locales)[number];
